import React, { createContext, useState, useEffect } from 'react';
import { shouldPersistAuth } from '../utils/deviceDetect';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    // Try localStorage first (mobile phones, owner/solution, saadhak)
    var saved = localStorage.getItem('auth');
    if (saved) {
      var parsed = JSON.parse(saved);
      // Restore sessionStorage tokens so api.js can attach them to requests
      // (sessionStorage is wiped when PWA/browser is fully closed)
      if (parsed.token) {
        sessionStorage.setItem('token', parsed.token);
        if (parsed.username) sessionStorage.setItem('lu', parsed.username);
      }
      return parsed;
    }
    // Fallback: sessionStorage (shared devices — survives refresh, cleared on browser close)
    var sessSaved = sessionStorage.getItem('auth');
    return sessSaved ? JSON.parse(sessSaved) : {};
  });

  useEffect(() => {
    if (auth && auth.token) {
      // Always keep sessionStorage tokens in sync for api.js
      sessionStorage.setItem('token', auth.token);
      if (auth.username) sessionStorage.setItem('lu', auth.username);

      if (shouldPersistAuth(auth.roles, auth)) {
        // Mobile phone / owner / solution / saadhak → persist across browser closes
        localStorage.setItem('auth', JSON.stringify(auth));
      } else {
        // Shared device staff → sessionStorage only (survives refresh, cleared on browser close)
        sessionStorage.setItem('auth', JSON.stringify(auth));
      }
    } else {
      // Logged out — clear both storages
      localStorage.removeItem('auth');
      sessionStorage.removeItem('auth');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('lu');
    }
  }, [auth]);

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
